import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="star"
export default class extends Controller {
  static targets = ["star", "scoreFormField"]
  count = null;;
  score = null;

  connect() {
    this.count = this.starTargets.length;

    this.starTargets.forEach(star => {
      star.addEventListener("mouseover", () => {
        this.score = parseInt(star.dataset.score) + 1;
        this.adjustStars();
      });
      star.addEventListener("mouseout", () => {
        this.score = parseInt(this.scoreFormFieldTarget.value);
        this.adjustStars();
      });
      star.addEventListener("click", () => {
        this.adjustStars();
        this.scoreFormFieldTarget.value = this.score;
      });
    });
  }

  adjustStars() {
    this.starTargets.forEach(star => {
      star.classList.remove("fa-star");
      star.classList.add("fa-star-o");
    });
    for (let i = 0; i < this.score; i++) {
      this.starTargets[i].classList.remove("fa-star-o");
      this.starTargets[i].classList.add("fa-star");
    }
  }
}
